import "./ShadowContainer.scss";
import AppleCareCardLogo from "../../assets/AppleCareLogo.svg";
import { Button, Typography } from "mobily-ui-library/lib";

interface Props {
  cardTitle?: string;
  cardSubTitle?: string;
  buttonTitle?: string;
  selectedAcPlan?: ((e?: any) => void) | undefined;
}
const ShadowContainer = ({
  cardTitle = "",
  cardSubTitle = "",
  buttonTitle = "",
  selectedAcPlan
}: Props) => {
  return (
    <div className="appleCareCard-div">
      <div className="appleCareCard-header">
        <div className="appleCareCard-text">
          <Typography className="appleCareCard-title">{cardTitle}</Typography>
          <Typography className="appleCareCard_description">{cardSubTitle}</Typography>
        </div>
        <img src={AppleCareCardLogo} alt="apple logo" className="AppleLogo" />

      </div>
      <Button
        id={"chooseCoverage"}
        className="appleCareCardbutton"
        onClick={selectedAcPlan}
        primary={true}>
        {buttonTitle}
      </Button>
    </div>
  );
};
export default ShadowContainer;
